export function cloneExtendedSourceItem(source) {
    return { ...source };
}
//# sourceMappingURL=ExtendedSourceItem.js.map